module.exports = __webpack_public_path__ + "static/media/29BDOS17.0f1678c0.jpg";